import { PromoterTypes } from '@mm/state/model/PromoterModel';
import { addSlashes } from '../../../../common/helpers/string-helpers';

type ChatProps = {
  appId: string;
  pageId: string;
  ref?: string;
  loggedInGreeting: string;
  loggedOutGreeting: string;
  themeColor: string;
};

type DefaultProps = {
  appId: string;
  pageId: string;
  ref?: string;
};

type MainProps = {
  type: string;
  appId: string;
  pageId: string;
  ref?: string;
  loggedInGreeting?: string;
  loggedOutGreeting?: string;
  themeColor?: string;
};

const getChatCode = ({
  appId,
  pageId,
  ref,
  loggedInGreeting,
  loggedOutGreeting,
  themeColor,
}: ChatProps) => {
  const strippedLoggedInGreeting = addSlashes(loggedInGreeting);
  const strippedLoggedOutGreeting = addSlashes(loggedOutGreeting);

  return `
    <script>
     var chatDiv = document.createElement('div');
     chatDiv.className = 'fb-customerchat';
     chatDiv.setAttribute('page_id', '${pageId}');
     chatDiv.setAttribute('ref', '${ref}');
     chatDiv.setAttribute('logged_in_greeting', "${strippedLoggedInGreeting}");
     chatDiv.setAttribute('logged_out_greeting', "${strippedLoggedOutGreeting}");
     chatDiv.setAttribute('theme_color', "${themeColor}");
     document.body.appendChild(chatDiv);
     window.fbAsyncInit = function() {
       FB.init({
         appId            : '${appId}',
         autoLogAppEvents : true,
         xfbml            : true,
         version          : 'v6.0'
       });
     };
     (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    </script>
  `;
};

/* tslint:disable */
const getCheckboxCode = ({ appId, pageId, ref }: DefaultProps) => `
<script>
  window.facebookPlugins = window.facebookPlugins ||
    {
      init : function() {
        FB.init({ appId: "${appId}", xfbml: true, version: "v6.0" });
      },
      cb : []
    };
  window.facebookPlugins.cb.push(function() {
    var user_ref, elements = document.querySelectorAll(".fb-messenger-checkbox[page_id='${pageId}']");
    if (elements) {
      for( i = 0; i < elements.length; i++ ) {
        user_ref = 'mobile-monkey_' + Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);
        elements[i].setAttribute('user_ref', user_ref);
        elements[i].setAttribute('origin', window.location.href);
        window.confirmOptIn = function() {
          FB.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, {
            app_id:"${appId}",
            page_id:"${pageId}",
            ref:"${ref}",
            user_ref: user_ref
          });
        };
      }
    }
  });
  window.fbAsyncInit = window.fbAsyncInit ||
    function() {
      window.facebookPlugins.cb.forEach( function( item ) {
        item();
      });
      window.facebookPlugins.init();
    };
    setTimeout( function() {
      (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }
    (document, 'script', 'facebook-jssdk')); }, 0);
</script>
<div
  class="fb-messenger-checkbox"
  origin=""
  page_id="${pageId}"
  messenger_app_id="${appId}"
  user_ref=""
  prechecked="true"
  allow_login="true"
  size="large"
></div>
`;
/* tslint:enable */

/* tslint:disable */
const getSendToMessengerPlugin = ({ appId, pageId, ref }: DefaultProps) => `
<script>
  window.facebookPlugins = window.facebookPlugins ||
    {
      init : function() {
        FB.init({ appId: "${appId}", xfbml: true, version: "v6.0" });
      },
      cb : []
    };
  window.facebookPlugins.cb.push(function() {
    var user_ref, elements = document.querySelectorAll(".fb-send-to-messenger[page_id='${pageId}']");
    if (elements) {
      for( i = 0; i < elements.length; i++ ) {
        user_ref = 'mobile-monkey_' + Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);
        elements[i].setAttribute('user_ref', user_ref);
        elements[i].setAttribute('origin', window.location.href);
      }
    }
  });
  window.fbAsyncInit = window.fbAsyncInit ||
    function() {
      window.facebookPlugins.cb.forEach( function( item ) {
        item();
      });
      window.facebookPlugins.init();
    };
     (function(d, s, id){
       var js, fjs = d.getElementsByTagName(s)[0];
       if (d.getElementById(id)) { return; }
       js = d.createElement(s);
       js.id = id;
       js.src = "//connect.facebook.net/en_US/sdk.js";
       fjs.parentNode.insertBefore(js, fjs);
     }
    (document, 'script', 'facebook-jssdk'));
</script>
  <div
    class="fb-send-to-messenger"
    messenger_app_id="${appId}"
    page_id="${pageId}"
    data-ref="${ref}"
    color="blue"
    size="large"
  >
  </div>
`;
/* tslint:enable */

const mapping = new Map([
  [PromoterTypes.CUSTOMER_CHAT, getChatCode],
  [PromoterTypes.CHECKBOX, getCheckboxCode],
  [PromoterTypes.MESSENGER, getSendToMessengerPlugin],
  [PromoterTypes.FB_COMMENT_GUARD, () => {}],
] as [string, any][]);

export default ({
  type,
  appId,
  pageId,
  ref,
  loggedInGreeting,
  loggedOutGreeting,
  themeColor,
}: MainProps) =>
  mapping.get(type)({
    appId,
    pageId,
    ref,
    loggedInGreeting,
    loggedOutGreeting,
    themeColor,
  });

export const titleByType = new Map([
  [PromoterTypes.LINK, 'Link'],
  [PromoterTypes.CUSTOMER_CHAT, 'Code'],
  [PromoterTypes.CHECKBOX, 'Code'],
  [PromoterTypes.MESSENGER, 'Code'],
] as [string, string][]);

export const textByType = new Map([
  [PromoterTypes.LINK, 'Share Link'],
  [PromoterTypes.CUSTOMER_CHAT, 'Customer chat'],
  [PromoterTypes.CHECKBOX, 'Checkbox'],
  [PromoterTypes.MESSENGER, 'Send to Messenger Button'],
] as [string, string][]);

export const checkboxCustomValue = 'window.confirmOptIn();';
